import { reactive, toRefs } from "vue"

interface AppState {
    registration?: ServiceWorkerRegistration,
    showUpdateSWBanner: boolean
}
const state = reactive<AppState>({
    showUpdateSWBanner: false
})

const updateServiceWorker = (registration: ServiceWorkerRegistration) => {
    state.registration = registration
    state.showUpdateSWBanner = true
}

const updateServiceWorkerConfirmed = () => {
    if (state.registration) {
        let registrationWaiting = state.registration.waiting

        if (registrationWaiting) {
            registrationWaiting.postMessage({ type: 'SKIP_WAITING' });

            registrationWaiting.addEventListener('statechange', (e: any) => {
                if (e?.target?.state === 'activated') {
                    window.location.reload();
                    state.showUpdateSWBanner = false
                }
            });
        }
    }
}

export default function useApp() {
    return { ...toRefs(state), updateServiceWorker, updateServiceWorkerConfirmed }
}